import { defineSlotRecipe } from '@chakra-ui/react';

export const sliderSlotRecipe = defineSlotRecipe({
  className: 'chakra-slider',
  slots: [
    'root',
    'label',
    'thumb',
    'valueText',
    'track',
    'range',
    'control',
    'markerGroup',
    'marker',
    'draggingIndicator',
  ],
  base: {
    root: {
      display: 'flex',
      borderRadius: 'none',
      cursor: 'pointer',
    },
    control: {
      borderRadius: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      touchAction: 'auto',
    },
    track: {
      overflow: 'hidden',
      borderRadius: 'none',
      flex: 1,
      backgroundColor: 'neutral.600 !important',
    },
    range: {
      width: 'inherit',
      height: 'inherit',
      backgroundColor: 'blue !important',
    },
    thumb: {
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      outline: 0,
      zIndex: '2',
      borderRadius: 'full',
      borderStyle: 'solid  !important',
      backgroundColor: 'skyBlue !important',
      color: 'skyBlue !important',
    },
  },
});
